import * as yup from "yup";

export type MakeSecondaryFormValues = {
    justification: string;
};

export const makeSecondaryFormValidationSchema = yup.object({
    justification: yup.string().required("Please enter a justification"),
});
